import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import { useMaintenanceWorkflowForwardings } from "@/features/privateCompanies/hooks/maintenance/workflows/useMaintenanceWorkflowForwardings";
import { MaintenaceWorkflowData } from "@/features/privateCompanies/types/maintenance/workflows/maintenanceWorkflows.type";
import { useMemo } from "react";
import { MaintenanceForwardingsDirectiveEntryKlass } from "../../../features/forwardings/types/maintenanceForwardingsDirectiveEntryKlasses.type";
import { MaintenanceWorkflowForwardingsData } from "../../../types/maintenanceWorkflowForwardings.type";
import MaintenanceWorkflowForwardingShow from "./MaintenanceWorkflowForwardingShow";
import MaintenanceWorkflowForwardingShowLoading from "./MaintenanceWorkflowForwardingShowLoading";

interface MaintenanceWorkflowForwardingsTabProps {
  workflow?: MaintenaceWorkflowData;
  directiveEntryKlass: MaintenanceForwardingsDirectiveEntryKlass;
}

const MaintenanceWorkflowForwardingsTab = ({ workflow, directiveEntryKlass }: MaintenanceWorkflowForwardingsTabProps) => {
  const {
    data: forwardings,
    isPending: forwardingsIsPending,
    error: forwardingsError = {} as any,
    refetch: refetchForwardings,
    dataUpdatedAt: forwardingsUpdatedAt,
  } = useMaintenanceWorkflowForwardings<MaintenanceWorkflowForwardingsData[]>({
    workflowId: workflow?.id,
    filters: {
      directiveEntryType: directiveEntryKlass,
    },
  });

  const forwarding = useMemo(() => {
    return forwardings?.[0];
  }, [forwardingsUpdatedAt]);

  if (forwardingsIsPending) {
    return <MaintenanceWorkflowForwardingShowLoading />
  }

  return (
    <ErrorMessageWrapper
      className="flex-1"
      statusCode={forwardingsError?.status}
      refetchFunction={refetchForwardings}
    >
      <div className="flex-1 overflow-auto flex flex-col">
        {forwarding && (
          <MaintenanceWorkflowForwardingShow
            key={forwarding.id}
            workflow={workflow}
            forwardingId={forwarding.id}
            directiveEntryKlass={directiveEntryKlass}
          />
        )}
      </div>
    </ErrorMessageWrapper>
  );
}

export default MaintenanceWorkflowForwardingsTab;
